import {Component, OnInit} from '@angular/core';
import {CommonService} from "../common.service";
import {ApiService} from '../api.service';
import {ActivatedRoute, Router} from '@angular/router';

declare var $: any;
declare var Hammer:any;
declare var echarts:any;

@Component({
  selector: 'app-ability-report',
  templateUrl: './ability-report.component.html',
  styleUrls: ['./ability-report.component.css']
})
export class AbilityReportComponent implements OnInit {


  report: any;//报告
  pageTitle: string; //  页面标题
  surveyStatus: number; //前后测类型： 1：前测  2：后测
  apiServiceUrl: string;//接口请求地址
  learningMetaId: number; //能力Id
  faceUrl: string; //笑脸图片url
  level: number; //能力等级
  levelDesc: string; //能力等级说明
  chartsOpt: any; //图表配置
  chartsData: any; //图表数据
  advantages: any;//优势
  short: any; //短板
  cid: number;//判断是否第一次进入报告
  learningPath: any; //学习路径
  learningPathId: number; //学习路径ID
  courseId: number; //课程ID
  courseName: string;//课程名称
  surveyTutor: string;//前侧引导话术
  goCourseFlag: boolean;//判断是否显示按钮

  beforeLevel: number; //诊断等级
  afterLevel: number; //考核等级

  beforeLevelName: string; //诊断等级名称
  afterLevelName: string; //考核等级名称

  beforeLevelDesc: string;//诊断等级详情
  afterLevelDesc: string; //考核等级详情

  beforeLevelAdvantages: any; //诊断等级优势
  afterLevelAdvantages: any;  //考核等级优势

  beforeLevelShort: any; //诊断等级劣势
  afterLevelShort: any;  //考核等级劣势

  learningTips: any; //学习建议
  developmentTips: string; //发展建议

  // finishStatus: number //完成状态
  // learningTour: boolean;
	//滑动对象
	hammertime:any;
  showInfo: boolean = true;
  isOpenClass:number = 0;
  isSlide: boolean = true;
  isClicked: boolean = true;

  constructor(private router: Router, private apiService: ApiService,private route: ActivatedRoute,
              private commonService: CommonService) { }

  ngOnInit() {
    this.isOpenClass = Number(localStorage.getItem('openClass'))?1:0;
     // this.mockData();
    setTimeout(()=>{
      this.isSlide = false;
    },4000);
     this.getApiData();
  }
	elementScroll($event){
		let nav = document.getElementById("surveyNav"),secOffset = document.getElementById("secondSection").offsetTop-100,thdOffset = document.getElementById("thirdSection").offsetTop-150;
    let clientHeight = $event.target.clientHeight, scrollTop = $event.target.scrollTop, scrollHeight = $event.target.scrollHeight;

    // console.log($event.target.clientHeight);
    // console.log($event.target.scrollTop);
    // console.log($event.target.scrollHeight);

    if ($event.target.scrollTop >= 150) {
        nav.style.display = "block";
        if($event.target.scrollTop >=secOffset &&$event.target.scrollTop< thdOffset ){
          $('#surveyNav ul li').eq(1).addClass('active').siblings().removeClass('active');
        }
        if($event.target.scrollTop >=thdOffset ||  clientHeight+scrollTop >= scrollHeight-1){
          $('#surveyNav ul li').eq(2).addClass('active').siblings().removeClass('active');
        }
        // if($event.target.scrollTop >=thdOffset ||  $event.target.scrollTop  >= $event.target.offsetHeight*0.9){
        //   $('#surveyNav ul li').eq(2).addClass('active').siblings().removeClass('active');
        // }

    }else{
      nav.style.display = "none";
      $('#surveyNav ul li').eq(0).addClass('active').siblings().removeClass('active');
    }
	}

  ngAfterViewInit(){
    $('body').addClass('heightAuto');
    this.commonService.initPage();
		let that = this;
    setTimeout(()=>{
      this.hammertime = new Hammer(document.getElementById('swipeContainer'));
      this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
      this.hammertime.on('swipeup swipedown', function(ev){
				that.logEventType(ev,that);
			});
    },500);


      setTimeout(()=>{
        let charts = echarts.init(document.getElementById('circleCharts'));
        charts.setOption(this.chartsOpt);
      },1500);
  }

  logEventType(ev,that){
    if(ev.type == "swipeup"){
      $('#swipeContainer').css({
        'top': '-100%',
        'opacity':'0'
      })

      that.hammertime.get('swipe').set({  enable: false  });

      setTimeout(()=>{
      	$(".abilityReport").css({'opacity':'1'});
      	$('#swipeContainer').hide();
      },300);
    }
  }

//   isBottom(target){
//     let clientHeight = target.scrollTop === 0 ? document.body.clientHeight : document.documentElement.clientHeight;
//     let scrollTop = target.scrollTop === 0 ? document.body.scrollTop : document.documentElement.scrollTop;
//     let scrollHeight = target.scrollTop === 0 ? document.body.scrollHeight : document.documentElement.scrollHeight;
//
//     console.log(clientHeight+';'+scrollTop+';'+scrollHeight);
//     if (clientHeight + scrollTop === scrollHeight) {
//       return true;
//     }else{
//       return false;
//     }
// }

  mockData(){
    let href = window.location.href.split('/');
    this.surveyStatus  =Number(href[href.length -1]);
    this.learningMetaId = Number(href[href.length -2]);
    if(this.surveyStatus == 1){
      this.pageTitle = "能力诊断报告";
      this.apiServiceUrl = '/survey/beforeTestRepote/';
    }else if(this.surveyStatus == 2){
      this.pageTitle = "能力考核报告";
      this.apiServiceUrl = '/survey/afterTestReport/';
    }

    this.level = 2;
    this.levelDesc = '123123';
    this.faceUrl = "../../assets/picture/reportnew/L"+this.level +".png";
    this.beforeLevel = 4;
    this.afterLevel = 2;

    this.beforeLevelName = 'aa';
    this.afterLevelName ='bb';

    this.beforeLevelDesc ='aaa';
    this.afterLevelDesc = 'bbb';

    let beforeAdvantages =  ['aaa','bbb'];
    let afterAdvantages =  ['aaa','bbb'];

    this.beforeLevelAdvantages = '<b>优势行为</b><br/><br/>';
    for(let i = 0, len = beforeAdvantages.length;i<len;i+=1){
      this.beforeLevelAdvantages+= beforeAdvantages[i]+'<br />';
    }

    this.afterLevelAdvantages = '<b>优势行为</b><br/><br/>';
    for(let i = 0, len = afterAdvantages.length;i<len;i+=1){
      this.afterLevelAdvantages+= afterAdvantages[i]+'<br />';
    }

    let beforeShort =  ['在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。','在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。'];
    let afterShort =  ['在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。','在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。'];

    this.beforeLevelShort = '<b>短板行为</b><br/><br/>';
    for(let i = 0, len = beforeShort.length;i<len;i+=1){
      this.beforeLevelShort+= beforeShort[i]+'<br />';
    }

    this.afterLevelShort = '<b>短板行为</b><br/><br/>';
    for(let i = 0, len = afterShort.length;i<len;i+=1){
      this.afterLevelShort+= afterShort[i]+'<br />';
    }

    this.courseName = '协作';
    this.surveyTutor = 'aldklasjdlkasjldajskldjlasdjldklasdklasjldjkasdklas';

    this.advantages = ['在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。','在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。'];
    this.short =['在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。','在授权上所展现的行为较为无效。未能选择合适的时机向他人授权，或在授权时难以完全放手，导致他人无法自主承担任务职责，并且未能及时向对方提供支持。'];
    // this.learningTips = [{'title':'1110','content':'435345'},{'title':'1110','content':'435345'}];
    this.learningTips = [{'content':'435345'},{'content':'435345'}];

    this.developmentTips = '以下方法可以帮助你更好发挥授权能力上的优势，以加速授权成果的展现，同时培养下属的能力：\n' +
      '1.根据任务/责任的性质和授权的风险，判断任务是否需要授权，如果需要授权，判断最有效的授权方式是征求建议、委派任务还是下放职权；\n' +
      '2.依据人员的能力、工作量和个人意愿，结合任务的复杂度和能力要求，综合分析各候选人在各方面的利和弊，对比后选择最佳的授权人选；\n' +
      '3.通过讨论，和被授权者就责任范围、决策范围和绩效期待以及能够提供的资源和支持达成共识；\n' +
      '4.在合适的时机，兑现所承诺提供的资源和支持，鼓励被授权者承担责任的同时，通过不断实践采用提供支持的最佳力度和方式；\n' +
      '5.在项目开始前制定一套追踪流程，项目进行中与被授权者定期沟通以监督进展状况，项目结束后，验收项目是否达到质量标准和时间期限。\n' +
      '发展活动：\n' +
      '被授权的任务完成后进行汇报或分析以检查结果，并就自己的授权表现及被授权者的执行效果征询其他人的反馈意见。';


    switch(this.level) {
      case 6:
        this.chartsData = [
          {value:10, name:'薄弱'},
          {value:10, name:'有限'},
          {value:10, name:'一般'},
          {value:10, name:'良好'},
          {value:10, name:'优秀'},
          {value:10, name:'卓越'},
          {value:0, name:'背景'},
          {value:20, name:'缺口'},
        ];
        break;
      case 5:
        this.chartsData = [
          {value:10, name:'薄弱'},
          {value:10, name:'有限'},
          {value:10, name:'一般'},
          {value:10, name:'良好'},
          {value:10, name:'优秀'},
          {value:0, name:'卓越'},
          {value:10, name:'背景'},
          {value:20, name:'缺口'},
        ];
        break;
      case 4:
        this.chartsData = [
          {value:10, name:'薄弱'},
          {value:10, name:'有限'},
          {value:10, name:'一般'},
          {value:10, name:'良好'},
          {value:0, name:'优秀'},
          {value:0, name:'卓越'},
          {value:20, name:'背景'},
          {value:20, name:'缺口'},
        ];
        break;
      case 3:
        this.chartsData = [
          {value:10, name:'薄弱'},
          {value:10, name:'有限'},
          {value:10, name:'一般'},
          {value:0, name:'良好'},
          {value:0, name:'优秀'},
          {value:0, name:'卓越'},
          {value:30, name:'背景'},
          {value:20, name:'缺口'},
        ];
        break;
      case 2:
        this.chartsData = [
          {value:10, name:'薄弱'},
          {value:10, name:'有限'},
          {value:0, name:'一般'},
          {value:0, name:'良好'},
          {value:0, name:'优秀'},
          {value:0, name:'卓越'},
          {value:40, name:'背景'},
          {value:20, name:'缺口'},
        ];
        break;
      case 1:
        this.chartsData = [
          {value:10, name:'薄弱'},
          {value:0, name:'有限'},
          {value:0, name:'一般'},
          {value:0, name:'良好'},
          {value:0, name:'优秀'},
          {value:0, name:'卓越'},
          {value:50, name:'背景'},
          {value:20, name:'缺口'},
        ];
        break;
    }
    this.chartsOpt = {
      tooltip : {
        show:false,
      },
      legend: {
        show: false,
      },
      toolbox: {
        show : false,
      },
      calculable : true,
      color:['#F14F0F','#F1860D','#E4B80B','#E6E812','#81C80F','#1BB500','rgb(90,102,150)','#3f4c84'],
      series : [
        {
          name:'访问来源',
          type:'pie',
          radius : ['91%', '100%'],
          hoverAnimation: false,
          startAngle: 225,
          // radius : ['25rem', '30rem'],
          itemStyle : {
            normal : {
              label : {
                show : false
              },
              labelLine : {
                show : false
              }
            },
            emphasis : {
              label : {
                show : false,
                position : 'center',
                textStyle : {
                  fontSize : '30',
                  fontWeight : 'bold'
                }
              }
            }
          },
          data: this.chartsData
        }
      ],
    };

  }

  getApiData(){
    this.route.params.subscribe(params => {
      this.learningMetaId = params['learningPathId'];
      this.surveyStatus = params['typeId'];

      if(this.surveyStatus == 1){
        this.pageTitle = "能力诊断报告";
        this.apiServiceUrl = '/survey/beforeTestRepote/';

      }else{
        this.pageTitle = "能力考核报告";
        this.apiServiceUrl = '/survey/afterTestReport/';
      }
      this.apiService.getOrCreateLearningPath(String(this.learningMetaId)).subscribe(result=>{
        if(result.lock!==1){
          this.goCourseFlag = true;
        }else{
          this.goCourseFlag = false;
        }
      })

      this.apiService.ajax({
        'type': 'GET',
        'url': '/sr'+ this.apiServiceUrl +this.learningMetaId,
        'data': {}
      }).subscribe(result=>{

        if(this.surveyStatus ==2 ){
          this.report = result;
          this.level = result.level;
          this.levelDesc = result.levelDesc;
          this.faceUrl = "../../assets/picture/reportnew/L"+this.level +".png";
          this.beforeLevel = result.afterTestContrasts.b_level;
          this.afterLevel = result.afterTestContrasts.a_level;

          this.beforeLevelName = result.afterTestContrasts.b_levelName;
          this.afterLevelName = result.afterTestContrasts.a_levelName;

          this.beforeLevelDesc = result.afterTestContrasts.b_levelDesc;
          this.afterLevelDesc = result.afterTestContrasts.a_levelDesc;

          let beforeAdvantages =  result.afterTestContrasts.b_advantages;
          let afterAdvantages = result.afterTestContrasts.a_advantages;

          this.beforeLevelAdvantages = '<b>优势行为</b><br/><br/>';
          for(let i = 0, len = beforeAdvantages.length;i<len;i+=1){
            this.beforeLevelAdvantages+= beforeAdvantages[i]+'<br />';
          }

          this.afterLevelAdvantages = '<b>优势行为</b><br/><br/>';
          for(let i = 0, len = afterAdvantages.length;i<len;i+=1){
            this.afterLevelAdvantages+= afterAdvantages[i]+'<br />';
          }

          let beforeShort = result.afterTestContrasts.b_shortBoards;
          let afterShort = result.afterTestContrasts.a_shortBoards;

          this.beforeLevelShort = '<b>短板行为</b><br/><br/>';
          for(let i = 0, len = beforeShort.length;i<len;i+=1){
            this.beforeLevelShort+= beforeShort[i]+'<br />';
          }

          this.afterLevelShort = '<b>短板行为</b><br/><br/>';
          for(let i = 0, len = afterShort.length;i<len;i+=1){
            this.afterLevelShort+= afterShort[i]+'<br />';
          }

          this.developmentTips = result.developmentTips;

        }else if(this.surveyStatus ==1){
          this.report = result;
          this.level = result.level;
          this.levelDesc = result.levelDesc;
          this.faceUrl = "../../assets/picture/reportnew/L"+this.level +".png";
          this.learningPathId = result.learningPathId;
          this.courseId = result.courseId;
          this.courseName = result.courseName;
          this.surveyTutor = result.surveyTutor;


          let learningTipsTop =  Object.keys(result.learningTips);

          //发展建议
          this.learningTips = [];
          for(let i = 0 ,len = learningTipsTop.length;i<len;i+=1){
            let obj = {};
            obj['title'] = learningTipsTop[i];
            obj['content'] = result.learningTips[learningTipsTop[i]];
            this.learningTips.push(obj);
          }

          //测试
          this.advantages = result.advantages;
          this.short = result.shortBoards;

        }

        switch(this.level) {
          case 6:
            this.chartsData = [
              {value:10, name:'薄弱'},
              {value:10, name:'有限'},
              {value:10, name:'一般'},
              {value:10, name:'良好'},
              {value:10, name:'优秀'},
              {value:10, name:'卓越'},
              {value:0, name:'背景'},
              {value:20, name:'缺口'},
            ];
            break;
          case 5:
            this.chartsData = [
              {value:10, name:'薄弱'},
              {value:10, name:'有限'},
              {value:10, name:'一般'},
              {value:10, name:'良好'},
              {value:10, name:'优秀'},
              {value:0, name:'卓越'},
              {value:10, name:'背景'},
              {value:20, name:'缺口'},
            ];
            break;
          case 4:
            this.chartsData = [
              {value:10, name:'薄弱'},
              {value:10, name:'有限'},
              {value:10, name:'一般'},
              {value:10, name:'良好'},
              {value:0, name:'优秀'},
              {value:0, name:'卓越'},
              {value:20, name:'背景'},
              {value:20, name:'缺口'},
            ];
            break;
          case 3:
            this.chartsData = [
              {value:10, name:'薄弱'},
              {value:10, name:'有限'},
              {value:10, name:'一般'},
              {value:0, name:'良好'},
              {value:0, name:'优秀'},
              {value:0, name:'卓越'},
              {value:30, name:'背景'},
              {value:20, name:'缺口'},
            ];
            break;
          case 2:
            this.chartsData = [
              {value:10, name:'薄弱'},
              {value:10, name:'有限'},
              {value:0, name:'一般'},
              {value:0, name:'良好'},
              {value:0, name:'优秀'},
              {value:0, name:'卓越'},
              {value:40, name:'背景'},
              {value:20, name:'缺口'},
            ];
            break;
          case 1:
            this.chartsData = [
              {value:10, name:'薄弱'},
              {value:0, name:'有限'},
              {value:0, name:'一般'},
              {value:0, name:'良好'},
              {value:0, name:'优秀'},
              {value:0, name:'卓越'},
              {value:50, name:'背景'},
              {value:20, name:'缺口'},
            ];
            break;
        }
        this.chartsOpt = {
          tooltip : {
            show:false,
          },
          legend: {
            show: false,
          },
          toolbox: {
            show : false,
          },
          calculable : true,
          color:['#F14F0F','#F1860D','#E4B80B','#E6E812','#81C80F','#1BB500','rgb(90,102,150)','#3f4c84'],
          series : [
            {
              name:'访问来源',
              type:'pie',
              radius : ['91%', '100%'],
              hoverAnimation: false,
              startAngle: 225,
              // radius : ['25rem', '30rem'],
              itemStyle : {
                normal : {
                  label : {
                    show : false
                  },
                  labelLine : {
                    show : false
                  }
                },
                emphasis : {
                  label : {
                    show : false,
                    position : 'center',
                    textStyle : {
                      fontSize : '30',
                      fontWeight : 'bold'
                    }
                  }
                }
              },
              data: this.chartsData
            }
          ],
        };

      });
    });
  }

  getCourse(){
    $('body').removeClass('heightAuto');
    this.apiService.ajax({
      'type':'GET',
      'url':'/sr/exposeoutapi/setAbilitySession/'+this.learningMetaId+'/2'
    }).subscribe(result=>{});

    this.apiService.ajax({
      'type': 'GET',
      'url': '/sr'+ this.apiServiceUrl +this.learningMetaId,
      'data': {}
    }).subscribe(result=>{
      this.learningPathId = result.learningPathId;
      let link = ['course', this.learningPathId, this.courseId];
      this.router.navigate(link);
    });

  }

  finishCourse(){
    $('body').removeClass('heightAuto');
    let link = ['learning-map'];
    this.router.navigate(link);
  }

  close() {
    $('body').removeClass('heightAuto');
    let link = ['learning-path',this.learningMetaId];
    this.router.navigate(link);
  }

  showStrong(){
    $('.strong').addClass('active');
    $('.weak').removeClass('active');
    $('.strongTxt').show();
    $('.shortTxt').hide();
  }

  showWeak(){
    $('.strong').removeClass('active');
    $('.weak').addClass('active');
    $('.strongTxt').hide();
    $('.shortTxt').show();
  }

  slideBtn(){
    if(this.isClicked){
      if(this.isSlide){
        $('#audioPlay').hide();
        // this.showInfo = false;
        // $('.experienceBtn').removeClass('slideUp');
        this.isSlide = false;
      }else{
        // $('.experienceBtn').addClass('slideUp');
        this.isSlide = true;
        setTimeout(()=>{
          this.isSlide = false;
        },3000);
        setTimeout(()=>{
          $('#audioPlay').show();
        },200);

      }
    }else{
      return false;
    }

  }

  changeTab(event){
  	let tabObject = $(event.target);
  	let reportObj = $('.abilityBody');
    tabObject.addClass('active').siblings().removeClass('active');
    reportObj.animate({
      scrollTop: reportObj.scrollTop() + $("."+tabObject.data('target')).offset().top - 90
    }, 20);
  }

}



// WEBPACK FOOTER //
// ./src/app/ability-report/ability-report.component.ts